module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAALCAYAAABPhbxiAAABH0lEQVQoU21S0W3EIAy1gQHSDTpCUBjgOkHvJqgyQdMJTjdCJ2g6QbNB7zshygjNBs0ABiojONHo/APYfs/2MwiFLctSEVGHiM8A8AgAFQCsIYRBKfWutV5zOubLNE0HRPxKyezeintOOxljBn5E4DzPXQjhnBI3RHwTQgxa621PiIht0zQ9juNYCyG+MzsHhBBXInplUqXUhYhqROScaN57jdZadhyyU0r5kObkDth6Y0xrrf0tWl8ZyHMdd8AzInbJNxhjTtbanyQYu6/ISjrnmC1aanUgIgZXUsqLc64GAC4QRfPeP0VxkgB5higOC5DWw/N9pGq32G0de5Ey+2497b915DaLD/CSK3BrIYRPpVR/9wNkcHkyEe/yXuwPePGHjkmY0CYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eyes.png
// module id = OdOY
// module chunks = 0